"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FlyingLetter_1 = require("./FlyingLetter");
exports.default = FlyingLetter_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/Loader/FlyingLetter/index.js
// module id = 1711
// module chunks = 8